document.addEventListener('alpine:init', () => {
  Alpine.data('commentableArea', (obj_id, is_assessment) => ({
    response_id: obj_id,
    is_assessment: is_assessment,
    selectedText: '',
    range: '',
    showButton: false,
    showModal: false,
    commentText: '',

    uid() {
      return (
        'id' +
        Date.now().toString(36) +
        Math.floor(
          Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)
        ).toString(36)
      )
    },

    getSelectedText() {
      const selection = window.getSelection()
      // Check if there is a selection and it has ranges
      if (!selection || selection.rangeCount === 0) {
        this.showButton = false
        return
      }

      let is_commented = this.isCommented(selection)
      const range = selection.getRangeAt(0)
      let text = range.toString()

      if (text.trim() !== '' && text.length > 3 && !is_commented) {
        this.range = range.cloneRange()
        this.selectedText = text
        this.showButton = true

        const rect = range.getBoundingClientRect()
        const containerRect = this.$refs.container.getBoundingClientRect()

        if (this.$refs.commentButton) {
          // Add safety check
          this.$refs.commentButton.style.position = 'absolute'
          this.$refs.commentButton.style.top = `${
            rect.bottom - containerRect.top + 5
          }px`
          this.$refs.commentButton.style.left = `${
            rect.left - containerRect.left + 10
          }px`
        }
      } else {
        this.showButton = false
      }
    },
    getSelectionHTML(sel) {
      if (sel.rangeCount) {
        var container = document.createElement('div')
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents())
        }
        html = container.innerHTML
        return html
      }
      return ''
    },
    isCommented(selection) {
      if (!selection || !selection.anchorNode || !selection.focusNode) {
        return false
      }

      const selectionHTML = this.getSelectionHTML(selection)
      const contains_full_comment = selectionHTML.includes('comment-selection')

      const anchorParent = selection.anchorNode.parentNode
      const focusParent = selection.focusNode.parentNode

      const is_comment_area =
        anchorParent &&
        anchorParent.classList &&
        anchorParent.classList.contains('comment')
      const start =
        anchorParent && anchorParent.id && anchorParent.id.slice(0, 2) === 'id'
      const end =
        focusParent && focusParent.id && focusParent.id.slice(0, 2) === 'id'

      return start || end || is_comment_area || contains_full_comment
    },
    openCommentModal() {
      this.showButton = false
      this.showModal = true

      const rect = this.range.getBoundingClientRect()
      const containerRect = this.$refs.container.getBoundingClientRect()

      // Position vertically based on selection, horizontally fixed from left edge
      const top = rect.bottom - containerRect.top + 5
      const left = 10 // Fixed 10px from left edge of container

      this.$refs.commentModal.style.position = 'absolute'
      this.$refs.commentModal.style.top = `${top}px`
      this.$refs.commentModal.style.left = `${left}px`

      this.commentText = ''
      this.$nextTick(() => this.$refs.commentText.focus())
    },
    deleteComment(commentId) {
      // Find the specific comment by ID
      const commentElement = this.$refs.commentary.querySelector(
        `#${commentId}`
      )
      if (commentElement) {
        // Get just the text content (without the comment span)
        const originalText = commentElement.firstChild.textContent
        // Replace the entire comment element with just the text
        commentElement.replaceWith(originalText)

        // Post the updated content using your existing postComment infrastructure
        const data = new URLSearchParams({
          obj_id: this.response_id,
          comment_id: commentId,
          comment: '', // Empty comment indicates deletion
          commented: this.$refs.commentary.innerHTML,
          is_assessment: this.is_assessment,
        })

        fetch('/teach/feedback/comment/upsert/', {
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
          .then((response) => {
            if (response.ok) {
              return response.text()
            }
            throw new Error('Network response was not ok.')
          })
          .then((responseText) => {
            this.$refs.container.outerHTML = responseText
            htmx.process(document.body)
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }
    },
    createCommentedElement() {
      let span = document.createElement('span')
      this.comment_id = this.uid()
      span.innerHTML = this.selectedText
      span.id = this.comment_id
      span.classList.add('highlight')
      span.classList.add('comment-selection')

      let text = document.createElement('span')
      text.classList.add('comment')

      // Add delete button
      let deleteBtn = document.createElement('button')
      deleteBtn.innerHTML = '×'
      // Add x-on:click attribute for Alpine.js event handling
      deleteBtn.setAttribute(
        'x-on:click',
        `deleteComment('${this.comment_id}', $event)`
      )
      deleteBtn.classList.add('delete-comment')

      text.appendChild(document.createTextNode(this.commentText))
      span.appendChild(text)
      text.appendChild(deleteBtn)

      return span
    },
    saveComment() {
      element = this.createCommentedElement()
      this.addCommentElement(element)
      this.postComment()
      this.showModal = false
    },

    addCommentElement(element) {
      if (this.range) {
        this.range.deleteContents()
        this.range.insertNode(element)
      }
    },

    postComment() {
      // Post comment and updated commented response,
      // replace page with the returned response.
      const data = new URLSearchParams({
        selected: this.selectedText,
        obj_id: this.response_id,
        comment_id: this.comment_id,
        comment: this.commentText,
        commented: this.$refs.commentary.innerHTML,
        is_assessment: this.is_assessment,
      })

      fetch('/teach/feedback/comment/upsert/', {
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.text()
          }
          throw new Error('Network response was not ok.')
        })
        .then((responseText) => {
          this.$refs.container.outerHTML = responseText
          htmx.process(document.body)
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    },
  }))
})
